export const faceSwapeCameraOptions = {
    photography: {
      cameraType: {
        label: '相機類型',
        options: {
          fullFrameDslr: '全幅單眼相機',
          apsC: 'APS-C 相機',
          mirrorless: '無反光鏡相機',
          mediumFormat: '中片幅相機',
          pointAndShoot: '傻瓜相機',
          phone: '手機相機'
        }
      },
      lensType: {
        label: '鏡頭類型',
        options: {
          standard: '標準鏡頭 (50mm f/1.8)',
          wideAngle: '廣角鏡頭 (35mm, 24mm)',
          mediumTelephoto: '中長焦鏡頭 (85mm, 105mm)',
          telephoto: '長焦鏡頭 (200mm, 300mm)',
          macro: '微距鏡頭',
          fisheye: '魚眼鏡頭',
          zoom: '變焦鏡頭 (24-70mm, 70-200mm)',
          prime: '定焦鏡頭 (35mm, 50mm, 85mm)',
          largeAperture: '大光圈鏡頭 (f/1.2, f/1.4)'
        }
      },
      focalLength: {
        label: '焦距',
        options: {
          ultraWide: '超廣角 (10mm-24mm)',
          wide: '廣角 (35mm, 50mm)',
          standard: '標準 (85mm, 105mm)',
          telephoto: '長焦 (200mm, 300mm)',
          superTelephoto: '超長焦 (400mm, 600mm)'
        }
      },
      aperture: {
        label: '光圈',
        options: {
          large: '大光圈 (f/1.2, f/1.4)',
          medium: '中光圈 (f/2.8, f/3.5)',
          small: '小光圈 (f/8, f/11)'
        }
      },
      shutterSpeed: {
        label: '快門速度',
        options: {
          fast: '快速快門 (1/1000s, 1/500s)',
          medium: '中速快門 (1/250s, 1/125s)',
          slow: '慢速快門 (1/60s, 1/30s)'
        }
      },
      iso: {
        label: 'ISO',
        options: {
          low: '低 ISO (100-400)',
          medium: '中 ISO (800-1600)',
          high: '高 ISO (3200-6400)'
        }
      },
      whiteBalance: {
        label: '白平衡',
        options: {
          auto: '自動',
          daylight: '日光',
          cloudy: '陰天',
          tungsten: '鎢絲燈',
          fluorescent: '螢光燈',
          custom: '自訂'
        }
      },
      focusMode: {
        label: '對焦模式',
        options: {
          singlePoint: '單點對焦',
          zone: '區域對焦',
          auto: '自動對焦',
          faceDetection: '人臉偵測對焦',
          tracking: '追蹤對焦',
          manual: '手動對焦'
        }
      },
      exposureMode: {
        label: '曝光模式',
        options: {
          auto: '自動曝光',
          shutterPriority: '快門優先',
          aperturePriority: '光圈優先',
          manual: '手動曝光',
          compensation: '曝光補償'
        }
      },
      shootingMode: {
        label: '拍攝模式',
        options: {
          single: '單張拍攝',
          burst: '連拍模式',
          timeLapse: '縮時攝影',
          slowMotion: '超慢動作'
        }
      },
      shootingAngle: {
        label: '拍攝角度',
        options: {
          high: '俯視角度 (向下看)',
          low: '仰視角度 (向上看)',
          front: '正面視角',
          side: '側面視角',
          fortyFive: '45度角'
        }
      },
      pose: {
        label: '姿勢',
        options: {
          power: '力量姿勢',
          walking: '行走姿勢',
          sCurve: 'S曲線姿勢',
          sitting: '坐姿',
          leaning: '倚靠姿勢',
          headshot: '頭像姿勢',
          handOnHip: '叉腰姿勢',
          candidLaugh: '自然笑容姿勢',
          highFashion: '高級時尚姿勢'
        }
      }
    }
  };
